"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeAddressQuotePremiumOutput = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../../commonFunctions");
var services_1 = require("@falcon/services");
var ChangeAddressQuotePremiumOutput = /** @class */ (function (_super) {
    __extends(ChangeAddressQuotePremiumOutput, _super);
    function ChangeAddressQuotePremiumOutput(props) {
        var _this = _super.call(this, props) || this;
        _this.resize = function () {
            _this.setState({
                bgHeight: _this.getBgHeight()
            });
        };
        _this.state = {
            bgHeight: 0
        };
        return _this;
    }
    ChangeAddressQuotePremiumOutput.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.resize);
        window.addEventListener('scroll', this.resize);
        this.setState({
            bgHeight: this.getBgHeight() + 100
        });
    };
    ChangeAddressQuotePremiumOutput.prototype.render = function () {
        return (React.createElement("div", { className: "home-premium-output" },
            React.createElement("div", { className: "top-section" },
                React.createElement("div", { className: "premium-info premium-info-home" }, this.renderChangeAddressMonthPrice()),
                this.renderBackgroundAligner()),
            React.createElement("div", { className: "bottom-section bottom-section-annual-home" }, this.renderExcess())));
    };
    ChangeAddressQuotePremiumOutput.prototype.renderExcess = function () {
        var policyHolder = this.props.interaction.policyHolder;
        var realEstate = this.props.interaction.realEstate[0];
        var buildings = (0, commonFunctions_1.getCoverLimitAmount)("BUILDINGS_CONTENTS", "BUILDINGS_LIMIT", this.props.interaction);
        var contents = (0, commonFunctions_1.getCoverLimitAmount)("BUILDINGS_CONTENTS", "CONTENTS_LIMIT", this.props.interaction);
        var realEstateAddress = (0, commonFunctions_1.getAddressLine1WithPostcode)(realEstate.address);
        var annualHomeExcesses = this.props.interaction.annualHomeExcesses;
        return (React.createElement("div", null,
            React.createElement("div", { className: "text-center" },
                React.createElement("p", { className: "mb-0" },
                    React.createElement("span", { className: "font-weight-bold" },
                        policyHolder.firstName,
                        " ",
                        policyHolder.lastName),
                    " (policyholder)"),
                React.createElement("p", { className: "mb-0" }, realEstateAddress),
                React.createElement("p", { className: "mb-0" },
                    React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(annualHomeExcesses.allOtherClaims)),
                    " excess"),
                React.createElement("p", { className: "mb-0" },
                    React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(buildings)),
                    " Buildings"),
                React.createElement("p", { className: "mb-0" },
                    React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(contents)),
                    " Contents"))));
    };
    ChangeAddressQuotePremiumOutput.prototype.renderChangeAddressMonthPrice = function () {
        var isMonthly = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
        var isAnnual = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL;
        var totalPremium = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.totalAmount;
        return (React.createElement("div", null,
            isMonthly &&
                React.createElement("div", null,
                    React.createElement("div", { id: "price", className: "price-home text-center font-family-display font-weight-bold pt-3" },
                        (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.monthlyPremium),
                        React.createElement("span", { className: "muli-bold-16" }, " / month*")),
                    React.createElement("p", { className: "text-center mb-0" },
                        (0, commonFunctions_1.getAmountToDisplay)(totalPremium),
                        " in total"),
                    React.createElement("br", null)),
            isAnnual && React.createElement(React.Fragment, null,
                React.createElement("div", { id: "price", className: "price-home text-center font-family-display font-weight-bold pt-5" },
                    (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.annualPremium),
                    " ",
                    React.createElement("span", { className: "muli-bold-16" }, "/ year*"),
                    React.createElement("br", null))),
            React.createElement("p", { className: "mb-0 all-figures" }, "*All figures include Insurance Premium Tax.")));
    };
    ChangeAddressQuotePremiumOutput.prototype.renderBackgroundAligner = function () {
        return (React.createElement("div", { className: "bg-wrapper" },
            React.createElement("div", { className: "bg", style: { height: this.state.bgHeight } },
                React.createElement("img", { className: "waves", src: "/img/Flow-waves.svg", alt: "Journey background waves" })),
            React.createElement("img", { className: "clouds-back", src: "/img/Flow-clouds-back.svg", alt: "Journey background clouds back" }),
            React.createElement("img", { className: "clouds-front", src: "/img/Flow-clouds-front.svg", alt: "Journey background clouds front" }),
            React.createElement("div", { className: "bg-fix" }),
            React.createElement("div", { className: "bg-fix-bottom" })));
    };
    ChangeAddressQuotePremiumOutput.prototype.getBgHeight = function () {
        var background = document.getElementsByClassName("bg")[0];
        if (!background) {
            return 0;
        }
        return background.getBoundingClientRect().bottom;
    };
    return ChangeAddressQuotePremiumOutput;
}(plugin_journey_1.WidgetBase));
exports.ChangeAddressQuotePremiumOutput = ChangeAddressQuotePremiumOutput;
//# sourceMappingURL=ChangeAddressQuotePremiumOutput.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/changeAddress/ChangeAddressQuotePremiumOutput.js
// module id = 3707
// module chunks = 0